export const VALID_ID = 'Must have a valid State ID, Passport, or SSN';
export const VALID_ID_AFFORDABLE =
  'Must have a valid State ID, Passport, SSN, or Alien Registration';
